import React, { useEffect, useState } from 'react';
import { usePosting } from '../Hooks';
import { Image, Placeholder } from 'react-frontier';
import { CDN_URL } from '../API';

interface PostingSidebarItemProps{
	id: number,
}

var PostingSidebarItem = (props: PostingSidebarItemProps)=>{
	var { loading, posting_name, posting_id } = usePosting(props.id, false);
	if(loading || !posting_name){
		return <div className="user placeholder business">
			<div className="avatar"></div>
			<div className="info">
				<Placeholder width={20} height={12} style={{ marginBottom: 2 }} />
				<Placeholder />
			</div>
		</div>
	}
	return <div className="user business">
		<div className="avatar">
			<Image src={`${CDN_URL}/posting/${posting_id}/small.webp`} fallbackComponent={(
				<i className='image icon' />
			)} />
		</div>
		<div className="info">
			<div className="meta">Empleo #{posting_id}</div>
			<div className="name">{posting_name}</div>
		</div>
	</div>
}

export default PostingSidebarItem;